import {React} from 'common'
import RawToolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Badge from '@mui/material/Badge'
import MenuIcon from '@mui/icons-material/Menu'
import MoreIcon from '@mui/icons-material/MoreVert'
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined'
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined'
import Search from 'components/Control/Search'
import {Box, Tooltip} from '@mui/material'
import {itemMenus} from 'constants/toolbar'
import useResponsive from 'logic/useResponsive'
import {useGetCurrentUserQuery} from 'store/Store'
import {useTranslation} from 'react-i18next'
import {ReactComponent as Logo} from 'assets/images/logo-no-background.svg'
import ColorModeContext from 'context/ColorModeContext'
import {useContext} from 'react'
import {useNavigate} from 'react-router-dom'
import {useAuthorization} from 'logic/useAuthorization'

const Toolbar = ({openMenu, onClickOpenMenu, handleProfileMenuOpen, handleMobileMenuOpen}) => {
    const {smallScreen} = useResponsive()
    const {data: user} = useGetCurrentUserQuery()
    const {t} = useTranslation()
    const {mode, toggleColorMode} = useContext(ColorModeContext)
    const {isSuper} = useAuthorization()
    const navigate = useNavigate()
    const isDarkMode = mode === 'dark'

    // Set up menu item handlers
    itemMenus.profile.onClick = handleProfileMenuOpen
    itemMenus.queue.onClick = () => navigate('/queues')
    return (
        <RawToolbar sx={{display: 'flex', justifyContent: 'space-between'}}>
            <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="open drawer"
                sx={{
                    marginInlineEnd: smallScreen ? 0 : 5,
                    ...(openMenu && {display: 'none'}),
                }}
                onClick={onClickOpenMenu}>
                <MenuIcon />
            </IconButton>
            {!smallScreen && <Logo style={{height: 15, width: 120}} />}
            <Search />
            <Box sx={{flexGrow: 1}} />
            <Box p={1}>{`${t('hello')} ${user?.firstName}`}</Box>
            <Tooltip title={isDarkMode ? t('menuItems.lightMode') : t('menuItems.darkMode')}>
                <IconButton color="inherit" onClick={toggleColorMode}>
                    {isDarkMode ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
                </IconButton>
            </Tooltip>
            <Box sx={{display: {xs: 'none', md: 'flex'}}}>
                {Object.values(itemMenus).map((item, index) => {
                    // Skip items that require super user if user is not super
                    if (item.superUserOnly && !isSuper()) {
                        return null
                    }

                    return (
                        <Tooltip key={index} title={t(item.title)}>
                            <IconButton onClick={item?.onClick} color="inherit">
                                <Badge badgeContent={item?.badgeContent} color={item?.badgeColor}>
                                    {item?.icon}
                                </Badge>
                            </IconButton>
                        </Tooltip>
                    )
                })}
            </Box>
            <Box sx={{display: {xs: 'flex', md: 'none'}}}>
                <IconButton color="inherit" onClick={handleMobileMenuOpen}>
                    <MoreIcon />
                </IconButton>
            </Box>
        </RawToolbar>
    )
}

export default Toolbar
